import React from 'react';
import Icon from 'components/UI/Icon';
import NavigationModal from './NavigationModal';
import { useNavigationModal } from './useNavigationModal';
import './NavigationHeader.scss';
import { useDispatch, useSelector } from 'react-redux';
import { navigateBack } from 'navigation';
import { useHistory, useLocation } from 'react-router';
import { push } from 'connected-react-router';
const MobileMenu = require('img/navigationIcons/menumobile.svg');
const BackButton = require('img/navigationIcons/backbutton.svg');
const LogoNoText = require('theme/logo-no-text.svg');
function NavigationHeader({ showBackButton }) {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const { isShown: isModalShown, toggle: toggleModal } = useNavigationModal();
    const isMobile = useSelector((state) => state.ui.isMobile);
    const showBackIcon = isMobile && (location.pathname.startsWith('/subscription') ||
        location.pathname.startsWith('/delivery') ||
        location.pathname.startsWith('/cart') ||
        location.pathname.startsWith('/product/') ||
        location.pathname.startsWith('/my-page') ||
        location.pathname.startsWith('/checkout') ||
        location.pathname.startsWith('/supplier') ||
        location.pathname.startsWith('/produsenter') ||
        location.pathname.startsWith('/produsent/') ||
        location.pathname.startsWith('/bedrift'));
    const isLandingPage = location.pathname === '/';
    const goBackIcon = (React.createElement("div", { className: "navigation-header__icon" }, showBackIcon ? (React.createElement(Icon, { svg: BackButton, size: "large", onClick: () => navigateBack(dispatch, history, location) })) : (React.createElement("div", { className: "navigation-header__icon--logo" },
        React.createElement(Icon, { svg: LogoNoText, size: "xlarge", onClick: () => dispatch(push('/')) })))));
    const landingPageIcon = (React.createElement("div", { className: "navigation-header__icon--logo" },
        React.createElement(Icon, { svg: LogoNoText, size: "xlarge" })));
    if (!isMobile) {
        return null;
    }
    return (React.createElement("div", { className: "navigation-header" },
        showBackButton && goBackIcon,
        isLandingPage && landingPageIcon,
        React.createElement("div", { id: 'navigation-header__text' }),
        React.createElement("div", { className: "navigation-header__menu-icon" },
            React.createElement(Icon, { svg: MobileMenu, size: "large", onClick: () => toggleModal() })),
        React.createElement(NavigationModal, { isShown: isModalShown, hide: toggleModal })));
}
export default NavigationHeader;
